import { Badge as BaseBadge, Colors } from "react-native-ui-lib";
import { SyncProgressStatus } from "../../../../utilities/setup/page-query";

export interface SyncProgressBadgeProps {
  label: string;
  status: SyncProgressStatus;
}

export const SyncProgressBadge = ({
  label,
  status,
}: SyncProgressBadgeProps) => {
  const additionalProps = {
    ...{ backgroundColor: "rgb(216, 217, 219)" },
    ...(status == SyncProgressStatus.COMPLETE && {
      backgroundColor: Colors.statusClosed,
    }),
    ...(status == SyncProgressStatus.ERROR && {
      backgroundColor: Colors.statusVoid,
    }),
  };

  const normalizedLabel = convertToCamelCase(label);

  return (
    <BaseBadge
      labelStyle={{ color: Colors.black }}
      {...additionalProps}
      label={normalizedLabel}
    ></BaseBadge>
  );
};

function convertToCamelCase(inputString: string): string {
  const words = inputString.toLowerCase().split("_");

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }

  return words.join(" ");
}
